module.exports = __webpack_public_path__ + "static/img/product_msy.60eb9b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product_msy.jpg
// module id = 0l2s
// module chunks = 1